<template>
  <div class="purchase-plan-desc">
    <div class="title">备注编辑</div>
    <div>
      <el-form ref="form" :model="form">
        <gj-textarea
            v-model="form.memo"
            :autosize="{ minRows: 4, maxRows: 4}"
            placeholder="最多输入200个字"
            maxlength="200"
            class="form-input">
        </gj-textarea>
        <span style="font-size: 12px;margin-top: 10px">{{ form.memo.length || 0 }}/200</span>
        <div style="float: right; margin-top: 8px;">
          <gj-button size="mini" @click="close" class="gj-btn">取消</gj-button>
          <gj-button size="mini" type="primary" @click="confirm" class="gj-btn" :loading="confirmLoading">确定</gj-button>
        </div>
      </el-form>

    </div>
    <div>

    </div>
  </div>
</template>

<script>
import {purchasePlanUpdateInfo} from "@/api/purchase";
import {defaultVal} from "@/utils/common";

export default {
  name: "app-product-plan-desc",
  props: {
    row: {
      required: true
    }
  },
  created() {
    this.form.memo = this.row.memo;
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        memo: null
      }
    }
  },
  methods: {
    close(){
      this.$emit('hide')
    },
    confirm() {
      if (this.form.memo && this.form.memo.length <= 200) {
        this.confirmLoading = true;
        purchasePlanUpdateInfo({
          id: this.row.id,
          memo: defaultVal(this.form.memo, null),
        })
            .then(() => {
              this.close();
              this.$emit('updateMemo');
            })
            .complete(() => this.confirmLoading = false);
      }else{
        this.$gjMessage.error("请输入备注，且不能超过200个字符")
      }
    }
  }
}
</script>

<style scoped lang="scss">
.purchase-plan-desc{
    padding: 0;
  .title{
    font-size: 12px;
    color: #333333;
    font-weight: 600;
    padding-bottom: 8px;
  }
  .gj-btn{
    display: inline-block;
    margin-top: 5px;
  }
}


</style>
